/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';
import { WatchListUIModuleContentTreatment } from './watch-list-uimodule-content-treatment';

/**
 * 
 * @export
 * @interface WatchListUiModuleBody
 */
export interface WatchListUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof WatchListUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof WatchListUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof WatchListUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof WatchListUiModuleBody
     */
    moduleType: WatchListUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof WatchListUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof WatchListUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof WatchListUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof WatchListUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof WatchListUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {WatchListUIModuleContentTreatment}
     * @memberof WatchListUiModuleBody
     */
    contentTreatment: WatchListUIModuleContentTreatment;
}

/**
    * @export
    * @enum {string}
    */
export enum WatchListUiModuleBodyModuleTypeEnum {
    WATCH_LIST = 'WATCH_LIST'
}



